/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { useDetailsStore } from "@/stores/useDetailsStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";
import Paper from "@mui/material/Paper";

import { colors } from "@dotnet/telematics-design-system";

import { ROUTES, TUTORIAL_IDS } from "../../../../../../shared";
import { useStyles } from "../../../../styles";
import AccordionDetailsCardTitleArea from "./components/AcordionDetailsCardTitleArea";

export interface AccordionDetailsCardProps {
  route: ROUTES;
  cardTitle?: string;
  children: ReactNode;
  maxCount?: number;
  currentCount?: number;
  quickTitleAction?: ReactNode;
  titleInlineIcon?: ReactNode;
  showTitleArea?: boolean;
  customStyle?: {};
  testId?: string;
}

const AccordionDetailsCard = ({
  route,
  cardTitle,
  maxCount,
  currentCount,
  quickTitleAction,
  children,
  titleInlineIcon,
  showTitleArea = true,
  customStyle,
  testId
}: AccordionDetailsCardProps) => {
  const { loading: isTableLoading } = useTableStoreByRoute(route);
  const { isLoading: isDetailsLoading } = useDetailsStore();

  const { firstCollapsablePaperCard } = useStyles();

  const displayLoader = isDetailsLoading || isTableLoading;

  return (
    <Paper
      data-testid={testId ?? TUTORIAL_IDS.AccordionDetailsCard}
      id={TUTORIAL_IDS.AccordionDetailsCard}
      css={css([
        firstCollapsablePaperCard,
        {
          border: `1px solid ${colors.gray200}`,
          margin: "24px 16px 24px 24px"
        },
        customStyle
      ])}
    >
      {showTitleArea && (
        <AccordionDetailsCardTitleArea
          title={cardTitle ?? ""}
          displayLoader={displayLoader}
          colors={colors}
          titleInlineAddition={
            maxCount ? `(${currentCount}/${maxCount})` : undefined
          }
          titleInlineIcon={titleInlineIcon}
          quickAction={quickTitleAction}
        />
      )}
      {children}
    </Paper>
  );
};

export default AccordionDetailsCard;
